import { useState, useEffect } from 'react';

export const useDotCount = () => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prevCount) => (prevCount + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return { dotCount };
};
